angular.module('SpidApp')

.controller('MoneyTransferSuperviseurController',
        ['$scope', 'MoneyTransfer', 'Toaster', 'MoneyTransferService', 'User', 'AgencyService', 'RouteSupervisor',
function ($scope,   MoneyTransfer,   Toaster,   MoneyTransferService,   User, AgencyService,   RouteSupervisor) {

        var agencyId = 0;
        $scope.form = {};
        $scope.sort = 'moneyTransfer.updated_at';
        $scope.asc = true;
    	
        var fetchAgencies = function () {
			return AgencyService.all().then(function(agencies) {
				if (!agencies) {
					return;
				}
				
				$scope.agencies = agencies;
				
				if (agencyId === 0) {
					agencyId = $scope.agencies[0].id
				}
				
				$scope.groupedAgencies = _.indexBy($scope.agencies, function (agency) {
					return agency.id
				});
				
				$scope.form.selectedAgency = $scope.groupedAgencies[agencyId]
				$scope.form.selectedAgencyId = ''+agencyId;
			});
		};

        fetchAgencies().then(function(){
        	loadCurrentAmount();
        });

        $scope.changeAgency = function() {
        	if (!$scope.form.selectedAgencyId) {
        		return;
        	}
        	agencyId = $scope.form.selectedAgencyId;
        	$scope.form.selectedAgency =  $scope.groupedAgencies[agencyId]
        	
        	loadCurrentAmount();
        }

        
        var loadCurrentAmount = function(){
        	return MoneyTransferService.findByAgencyId(agencyId).then(function (listeMoneyTransfer){
        		$scope.moneyTransfers = listeMoneyTransfer
        		var lastElemListeMoneyTransfer =  _.chain(listeMoneyTransfer)
        										   .sortBy('updated_at')
        										   .last()
        										   .value()

        		if(lastElemListeMoneyTransfer !== null && _.size(lastElemListeMoneyTransfer) > 0){
            		$scope.currentAmount = lastElemListeMoneyTransfer.current
        		} else {
            		$scope.currentAmount = 0
        		}
        		$scope.isPositifCurrentAmount = $scope.currentAmount >= 0
        	})
        }
        
        $scope.$on('changeRoleEvent', function(event, args) {
        	RouteSupervisor.bounce(event, args.role);
        });
}])